// extracted by mini-css-extract-plugin
module.exports = {"tenantMenu":"TenantContextMenu_tenantMenu__hebUT"};